
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invasion/progress",
      function () {
        return require("private-next-pages/invasion/progress.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invasion/progress"])
      });
    }
  